<template>
    <v-container
        fluid
        no-gutters
        class="popup-inner-wrapper pa-0"
    >
        <v-row
            class="popup_head"
            no-gutters
        >
            <a
                href="#"
                class="popup-close_custom"
                @click.prevent="closePopup"
            >
                <span/>
            </a>
        </v-row>

        <v-row
            class="popup_body"
            ref="popup"
            no-gutters
        >
            <!-- Zoom -->
            <v-col cols="6">
                <v-row
                    class="text-center pa-2"
                    no-gutters
                >
                    <v-col
                        cols="6"
                        class="pa-2"
                    >
                        <v-icon large>
                            icon-zoom-in
                        </v-icon>
                    </v-col>
                    <v-col
                        cols="6"
                        class="pa-2"
                    >
                        <v-icon large>
                            icon-zoom-out
                        </v-icon>
                    </v-col>
                    <v-col
                        cols="12"
                        class="pa-2"
                    >
                        <span v-html="$t('navPopup.steps[0].messages[1]')"/>
                    </v-col>
                </v-row>
            </v-col>
            <!-- /Zoom -->

            <!-- Move -->
            <v-col
                cols="6"
                style="border-left: 1px solid black;"
            >
                <v-row
                    class="text-center pa-2"
                    no-gutters
                >
                    <v-col
                        cols="4"
                        class="pa-2"
                    >
                        <v-icon large>
                            icon-arrow-left-alternative
                        </v-icon>
                    </v-col>
                    <v-col
                        cols="4"
                        class="pa-2"
                    >
                        <v-icon large>
                            icon-stump
                        </v-icon>
                    </v-col>
                    <v-col
                        cols="4"
                        class="pa-2"
                    >
                        <v-icon large>
                            icon-arrow-right-alternative
                        </v-icon>
                    </v-col>
                    <v-col
                        cols="12"
                        class="pa-2"
                    >
                        <span v-html="$t('navPopup.steps[0].messages[0]')"/>
                    </v-col>
                </v-row>
            </v-col>
            <!-- /Move -->

            <!-- Autorotate -->
            <v-col
                cols="6"
                style="border-top: 1px solid black;"
            >
                <v-row
                    class="text-center pa-2"
                    no-gutters
                >
                    <v-col
                        cols="12"
                        class="pa-2"
                    >
                        <v-icon large>
                            icon-video
                        </v-icon>
                    </v-col>
                    <v-col
                        cols="12"
                        class="pa-2"
                    >
                        <span v-html="$t('navPopup.steps[0].messages[2]')"/>
                    </v-col>
                </v-row>
            </v-col>
            <!-- /Autorotate -->

            <!-- Full screen -->
            <v-col
                cols="6"
                style="border-left: 1px solid black; border-top: 1px solid black;"
            >
                <v-row
                    class="text-center pa-2"
                    no-gutters
                >
                    <v-col
                        cols="12"
                        class="pa-2"
                    >
                        <v-icon large>
                            icon-full-screen
                        </v-icon>
                    </v-col>
                    <v-col
                        cols="12"
                        class="pa-2"
                    >
                        <span v-html="$t('navPopup.steps[0].messages[3]')"/>
                    </v-col>
                </v-row>
            </v-col>
            <!-- /Full screen -->

            <!-- Screen-rotate -->
            <v-col
                cols="6"
                style="border-top: 1px solid black;"
            >
                <v-row
                    class="text-center pa-2"
                    no-gutters
                >
                    <v-col
                        cols="12"
                        class="pa-2"
                    >
                        <v-icon large>
                            icon-screen-rotate
                        </v-icon>
                    </v-col>
                    <v-col
                        cols="12"
                        class="pa-2"
                    >
                        <span v-html="$t('navPopup.steps[0].messages[4]')"/>
                    </v-col>
                </v-row>
            </v-col>
            <!-- /Screen-rotate -->

            <!-- Cookie disclaimer -->
            <v-col
                cols="6"
                style="border-left: 1px solid black; border-top: 1px solid black;"
            >
                <v-row
                    class="text-center pa-2"
                    no-gutters
                >
                    <v-col
                        cols="12"
                        class="pa-2"
                    >
                        <v-icon large>
                            icon-shield-check
                        </v-icon>
                    </v-col>
                    <v-col
                        cols="12"
                        class="pa-2"
                    >
                        <a
                            href="#"
                            class="text-none"
                            @click.prevent="openCookieDisclaimerPopup"
                        >
                            <span v-html="$t('navPopup.steps[0].messages[5]')"/>
                        </a>
                    </v-col>
                </v-row>
            </v-col>
            <!-- /Cookie disclaimer -->
        </v-row>
    </v-container>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'HelpPopup',
        methods: {
            ...mapActions([
                'toggleCookieDisclaimer'
            ]),
            closePopup() {
                this.$emit('close-help-popup');
            },
            openCookieDisclaimerPopup() {
                this.$emit('close-help-popup');
                this.toggleCookieDisclaimer();
            }
        }
    }
</script>

<style lang="scss" scoped>
    a {
        pointer-events: auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/threeDController/components/HelpPopup.vue